import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CameraIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.43045 6.26977C9.43045 6.26978 9.43046 6.26975 9.43045 6.26977L8.8397 7.8499H5.50002C5.14134 7.8499 4.85002 8.14122 4.85002 8.4999V17.4999C4.85002 17.8586 5.14134 18.1499 5.50002 18.1499H18.5C18.8587 18.1499 19.15 17.8586 19.15 17.4999V8.4999C19.15 8.14122 18.8587 7.8499 18.5 7.8499H15.162L14.5665 6.26977C14.4722 6.01805 14.2306 5.8499 13.9594 5.8499H10.0375C9.76633 5.8499 9.52469 6.01807 9.43045 6.26977ZM7.83835 5.67379C8.18162 4.75675 9.05873 4.1499 10.0375 4.1499H13.9594C14.938 4.1499 15.8149 4.75645 16.1583 5.67311C16.1584 5.67334 16.1582 5.67289 16.1583 5.67311L16.338 6.1499H18.5C19.7976 6.1499 20.85 7.20234 20.85 8.4999V17.4999C20.85 18.7975 19.7976 19.8499 18.5 19.8499H5.50002C4.20246 19.8499 3.15002 18.7975 3.15002 17.4999V8.4999C3.15002 7.20234 4.20246 6.1499 5.50002 6.1499H7.66035L7.83835 5.67379ZM12 11.0999C10.9538 11.0999 10.1 11.9537 10.1 12.9999C10.1 14.0461 10.9538 14.8999 12 14.8999C13.0462 14.8999 13.9 14.0461 13.9 12.9999C13.9 11.9537 13.0462 11.0999 12 11.0999ZM8.40002 12.9999C8.40002 11.0148 10.015 9.3999 12 9.3999C13.9851 9.3999 15.6 11.0148 15.6 12.9999C15.6 14.985 13.9851 16.5999 12 16.5999C10.015 16.5999 8.40002 14.985 8.40002 12.9999Z"
      fill={color}
    />
  </Svg>
);

export default CameraIcon;
